import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import axios from "axios";
import config from "../config";
import Icon from "../sections/MUI/Icon";

class Chats extends Component {

    state = {
        chats: []
    };

    componentDidMount() {
        this.getChats();
    }

    getChats() {
        axios.get(`${config.api}/admin/goftino/chats?token=${config.token}`)
            .then(r => {
                this.setState({chats: r.data});
            })
            .catch(err => {
                config.handleError(err);

            });
    }

    render() {
        const {chats} = this.state;
        return (
            <div className="chats">
                <Back {...this.props}/>

                <br/>
                <Icon i="sync" onClick={() => this.getChats()} className="sync-icon"/>
                <br/>
                <div className="list">
                    {chats.map((ch, id) =>
                        <article key={"chat" + id} onClick={() => this.props.navigate(`/chat/messages/${ch.id}`)}>
                            <p className="name">
                                <span className="name">{ch.name}</span>
                                <span className="status"
                                      style={{color: ch.status === "open" ? "#0938da" : "#da0909"}}>{ch.status === "open" ? "باز" : "بسته"}</span>
                            </p>
                            <p><span>خوانده نشده:</span><span>{ch.unread}</span></p>
                            {
                                ch.lastMessage ?
                                    <div className="last-message">
                                        <p className="text">{ch.lastMessage.text}</p>
                                        <p className="date">{ch.lastMessage.date}</p>
                                    </div>
                                    : null
                            }

                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(Chats);